import {charcoal} from '../sass/base/_exports.sass';

export const ExpandIcon = (props) => {
  const {color = charcoal, className = '', ratio = 1} = props;

  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 25 25"
      style={style}
      fill="none"
    >
      <path
        d="M21.5 15.469L19.379 17.59L16.207 14.418L14.793 15.832L17.965 19.004L15.844 21.125H21.5V15.469ZM3.5 8.781L5.621 6.66L8.793 9.832L10.207 8.418L7.035 5.246L9.156 3.125H3.5V8.781ZM21.5 3.125H15.844L17.965 5.246L14.793 8.418L16.207 9.832L19.379 6.66L21.5 8.781V3.125ZM3.5 21.125H9.156L7.035 19.004L10.207 15.832L8.793 14.418L5.621 17.59L3.5 15.469V21.125Z"
        fill={color}
      />
    </svg>
  );
};
